// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__14gic","errorLogs":"EditorFooter_errorLogs__3JJfe"};